import { getGridNumericOperators } from '@mui/x-data-grid-pro'
import { FilterOperator, FilterTypes } from '@typings/graphql'

export const getFilterString = (operator: FilterOperator, type: FilterTypes): string => {
  if (type === FilterTypes.Perimeter) {
    return 'equals'
  }

  switch (operator) {
    case FilterOperator.Like:
      return 'contains'
    case FilterOperator.Eq:
      return type === FilterTypes.Boolean ? 'is' : 'equals'
    case FilterOperator.Is:
      return 'is'
    case FilterOperator.Lt:
      return 'before'
    case FilterOperator.Gt:
      return 'after'
    case FilterOperator.Lte:
      return 'onOrBefore'
    case FilterOperator.Gte:
      return 'onOrAfter'
    default:
      throw new Error(`Unsupported FilterOperator: ${operator}`)
  }
}

export const getMappedFilterOperator = (filter: string, type: FilterTypes): FilterOperator => {
  if (type === FilterTypes.Perimeter) {
    return FilterOperator.Eq
  }

  switch (filter) {
    case 'contains':
      return FilterOperator.Like
    case 'equals':
      return FilterOperator.Eq
    case 'is':
      return type === FilterTypes.Boolean ? FilterOperator.Is : FilterOperator.Eq
    case 'before':
      return FilterOperator.Lt
    case 'after':
      return FilterOperator.Gt
    case 'onOrBefore':
      return FilterOperator.Lte
    case 'onOrAfter':
      return FilterOperator.Gte
    case '=':
      return FilterOperator.Eq
    case '<':
      return FilterOperator.Lt
    case '<=':
      return FilterOperator.Lte
    case '>':
      return FilterOperator.Gt
    case '>=':
      return FilterOperator.Gte
    default:
      return filter as FilterOperator
  }
}

export const getNumericOperators = () => {
  return getGridNumericOperators().filter((operator) =>
    operator.value !== 'isEmpty' && operator.value !== 'isNotEmpty' && operator.value !== 'isAnyOf' && operator.value !== '!='
  )
}
